export default "__VITE_ASSET__6jtzXrdU__"